"use client";

import { c as _c } from "react/compiler-runtime";
import { EventEnum } from "@sprawdzonabron/shared";
import { usePlausible } from "next-plausible";
import { useCallback } from "react";
export const useAnalyticsEvent = event => {
  const $ = _c(3);
  const plausible = usePlausible();
  let t0;
  if ($[0] !== event || $[1] !== plausible) {
    t0 = info => {
      if (process.env.NODE_ENV === "development") {
        console.log("analytical event:", event, info);
      } else {
        plausible(event, {
          props: {
            info
          }
        });
      }
    };
    $[0] = event;
    $[1] = plausible;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};